module.exports = __webpack_public_path__ + "img/deer.d8d79cf1.gif";